import { AddIcon, Button, Grid, GridRow } from '@bp/ui-components';
import { FieldArray, useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { v4 } from 'uuid';
import { CurriculumFormType } from '../../types';
import { CurriculumTeachersFormItem } from './CurriculumTeachersFormItem';

export const CurriculumTeachersForm = () => {
  const { t } = useTranslation();

  const formik = useFormikContext<CurriculumFormType>();

  return (
    <FieldArray name={'teachers'}>
      {(arrayHelpers) => {
        return (
          <Grid useFormGap>
            {formik.values.teachers
              ?.sort((a, b) => {
                return a.order - b.order;
              })
              ?.map((person, index) => {
                return (
                  <CurriculumTeachersFormItem
                    key={person.order + index}
                    index={index}
                    onDelete={() => arrayHelpers.remove(index)}
                  />
                );
              })}
            <GridRow spacingTop='none' spacingBottom='none'>
              <Button
                hierarchy='tertiary'
                icon={<AddIcon />}
                disabled={!formik.values.subject}
                onClick={async () => {
                  if (formik.values.teachers && formik.values.teachers.length > 0) {
                    for (const index in formik.values.teachers) {
                      await formik.setFieldTouched(`teachers.${index}`);
                    }
                  }
                  arrayHelpers.push({ uuid: v4(), teachingLoad: true, present: true });
                }}
              >
                {t('persons.addTeacher')}
              </Button>
            </GridRow>
          </Grid>
        );
      }}
    </FieldArray>
  );
};
